export const fetchStatusEnum = {
  NOT_STARTED: 'not_started',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  BAD_DATA: 'bad_data',
};